// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Götter-Alias für den Feed: abgewandelte Fantasienamen nach nordischen/
// griechischen Gottheiten — bewusst verfremdet, nie echte Namen.

export const GOETTER_VORSCHLAEGE: string[] = [
  // nordisch angelehnt
  "Thorvik",
  "Lokjar",
  "Odinsson",
  "Freyala",
  "Heimdor",
  "Baldrin",
  "Tyrvald",
  "Njordin",
  "Skadira",
  "Sifka",
  "Ullrik",
  "Idunja",
  // griechisch angelehnt
  "Zeuson",
  "Herakleon",
  "Athenya",
  "Aresk",
  "Apollix",
  "Artemira",
  "Hermeon",
  "Poseidor",
  "Nyxa",
  "Helioz",
  "Selenya",
  "Kronix",
]

/** Zufälliger Vorschlag, der nicht in `taken` vorkommt (Groß/Klein egal). */
export function zufallsAlias(taken: string[]): string {
  const vergeben = new Set(taken.map((s) => s.trim().toLowerCase()))
  const frei = GOETTER_VORSCHLAEGE.filter((n) => !vergeben.has(n.toLowerCase()))
  if (frei.length) return frei[Math.floor(Math.random() * frei.length)]
  // Alles vergeben: Name kürzen + 3 Ziffern anhängen, bleibt ≤12 Zeichen.
  const basis = GOETTER_VORSCHLAEGE[Math.floor(Math.random() * GOETTER_VORSCHLAEGE.length)]
  return basis.slice(0, 9) + String(100 + Math.floor(Math.random() * 900))
}
